<template>
  <IQOS required :title="$t('settings.password.title')">
    <form class="gap-row-xs mt-16" @submit.prevent="onChangePassword">
      <BaseInput
        type="password"
        fullWidth
        :placeholder="$t('settings.password.current')"
        :readonly="false"
        v-model="form.current"
        position="center"
        required
        v-if="!success"
      />
      <!-- <h4 class="password-label c-white">{{$t('settings.password.new')}}</h4> -->
      <BaseInput
        type="password"
        fullWidth
        :placeholder="$t('settings.password.new')"
        :readonly="false"
        v-model="form.password"
        position="center"
        :valid="!error"
        @blur="error = null"
        required
        v-if="!success"
      />
      <!-- <h4 class="password-label c-white">{{}}</h4> -->
      <BaseInput
        type="password"
        fullWidth
        :placeholder="$t('settings.password.repeat')"
        :readonly="false"
        v-model="form.repeat"
        position="center"
        @blur="error = null"
        :valid="!error"
        required
        v-if="!success"
      />

       <div class="qrw-paragraph-md red-4-color" v-if="error">{{ error }}</div>
        <BaseDivider color="v1-grey-4" />
       <div class="iqos-flex-right"> 
        <BaseButton variant="secondary" size="md" v-if="!success">{{$t('settings.password.change')}}</BaseButton>
       </div>

      <div
        class="qrw-paragraph-md v1-grey-10-color"
        v-if="success"
      >{{$t('settings.password.success')}}</div>
    </form>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import BlackInput from "@/components/BlackInput.vue";

import AuthAPI from "@/api/auth";

import DashboardButton from "@/components/DashboardButton.vue";

export default {
  data() {
    return {
      form: {
        current: null,
        password: null,
        repeat: null
      },
      error: null,
      success: false
    };
  },
  methods: {
    onChangePassword() {
      this.error = null;
      if (this.form.password != this.form.repeat) {
        this.error = this.$t("settings.password.errord");
        return;
      }

      AuthAPI.changePassword(this.form.current, this.form.password)
        .then(ok => {
          this.success = true;
        })
        .catch(error => {
          this.error = this.$t("settings.password.erroro");
        });
    }
  },
  components: {
    IQOS,
    BlackInput,
    DashboardButton
  }
};
</script>

<style scoped>
.password-input {
  width: 100%;
}

h4 {
  margin: 1.7vh 0 1.1vh 0;
  font-size: 2vh;
}

h4:first-child {
  margin: 0 0 1.1vh 0;
}

.confirm-button {
  background: #129b81;
  margin-top: 2.5vh;
  padding: 0.5vh 0;
  color: white;
  border-radius: 1vh;
  border: none;
  font-size: 2.7vh;
  cursor: pointer;
  width: 100%;
}

.error-block {
  text-align: center;
}

.success-block {
  font-size: 2vh;
  text-align: center;
}
</style>